import React from 'react'
import { Link } from 'react-router-dom'
import Portimg1 from '../../../assets/images/portfolio/portfolio-details-1.jpg'
import Portimg2 from '../../../assets/images/portfolio/portfolio-details-2.jpg'
import Portsvg1 from '../../../assets/images/portfolio/Aerrow-right.svg'

const Portfolio = () => {
    return (
        <>
            <div className="portfolio-section-five">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 m-auto">
                            <div className="heading-box text-center">
                                <span
                                    className="sub-title animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                >
                                    Portfolio
                                </span>
                                <h2
                                    className="heading-title animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="200ms"
                                >
                                    Have a view of our&nbsp;amazing projects&nbsp;with our clients
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row gutter-x-15 gutter-y-60">
                        <div className="col-lg-6">
                            <div
                                className="portfolio-box-five animate fadeInUp wow animated"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <div className="portfolio-image-five">
                                    <img
                                        src={Portimg1}
                                        alt="portfolio-image"
                                    />
                                </div>
                                <div className="portfolio-details-five">
                                    <div className="portfolio-title-five">
                                        <h4>
                                            <Link to="/Details">
                                                Bank Credit Collection System
                                            </Link>
                                        </h4>
                                        <p>Corporate - Business Collection</p>
                                    </div>
                                    <Link to="/Details" className="portfolio-btn-five">
                                        <img src={Portsvg1} alt="icon" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div
                                className="portfolio-box-five animate fadeInUp wow animated"
                                data-wow-duration="1500ms"
                                data-wow-delay="400ms"
                            >
                                <div className="portfolio-image-five">
                                    <img
                                        src={Portimg2}
                                        alt="portfolio-image"
                                    />
                                </div>
                                <div className="portfolio-details-five">
                                    <div className="portfolio-title-five">
                                        <h4>
                                            <Link to="/Details">Creative Product Idea</Link>
                                        </h4>
                                        <p>Corporate - Business Collection</p>
                                    </div>
                                    <Link to="/Details" className="portfolio-btn-five">
                                        <img src={Portsvg1} alt="icon" />
                                    </Link>
                                </div>
                            </div>
                        </div >
                        <div className="col-lg-6">
                            <div
                                className="portfolio-box-five animate fadeInUp wow animated"
                                data-wow-duration="1500ms"
                                data-wow-delay="600ms"
                            >
                                <div className="portfolio-image-five">
                                    <img
                                        src="assets/images/portfolio/portfolio-details-3.jpg"
                                        alt="portfolio-image"
                                    />
                                </div>
                                <div className="portfolio-details-five">
                                    <div className="portfolio-title-five">
                                        <h4>
                                            <Link to="/Details">
                                                Investment Report For Business
                                            </Link>
                                        </h4>
                                        <p>Corporate - Business Collection</p>
                                    </div>
                                    <Link to="/Details" className="portfolio-btn-five">
                                        <img src={Portsvg1} alt="icon" />
                                    </Link>
                                </div>
                            </div >
                        </div >
                        <div className="col-lg-6">
                            <div
                                className="portfolio-box-five animate fadeInUp wow animated"
                                data-wow-duration="1500ms"
                                data-wow-delay="800ms"
                            >
                                <div className="portfolio-image-five">
                                    <img
                                        src="assets/images/portfolio/portfolio-details-4.jpg"
                                        alt="portfolio-image"
                                    />
                                </div>
                                <div className="portfolio-details-five">
                                    <div className="portfolio-title-five">
                                        <h4>
                                            <Link to="/Details">New Ideas For Productivity</Link>
                                        </h4>
                                        <p>Corporate - Business Collection</p>
                                    </div>
                                    <Link to="/Details" className="portfolio-btn-five">
                                        <img src={Portsvg1} alt="icon" />
                                    </Link>
                                </div>
                            </div >
                        </div >
                        <div className="col-lg-6">
                            <div
                                className="portfolio-box-five animate fadeInUp wow animated"
                                data-wow-duration="1500ms"
                                data-wow-delay="1000ms"
                            >
                                <div className="portfolio-image-five">
                                    <img
                                        src="assets/images/portfolio/portfolio-details-5.jpg"
                                        alt="portfolio-image"
                                    />
                                </div>
                                <div className="portfolio-details-five">
                                    <div className="portfolio-title-five">
                                        <h4>
                                            <Link to="/Details">Innovative Product Concepts</Link>
                                        </h4>
                                        <p>Corporate - Business Collection</p>
                                    </div>
                                    <Link to="/Details" className="portfolio-btn-five">
                                        <img src={Portsvg1} alt="icon" />
                                    </Link>
                                </div>
                            </div >
                        </div >
                        <div className="col-lg-6">
                            <div
                                className="portfolio-box-five animate fadeInUp wow animated"
                                data-wow-duration="1500ms"
                                data-wow-delay="1200ms"
                            >
                                <div className="portfolio-image-five">
                                    <img
                                        src="assets/images/portfolio/portfolio-details-6.jpg"
                                        alt="portfolio-image"
                                    />
                                </div>
                                <div className="portfolio-details-five">
                                    <div className="portfolio-title-five">
                                        <h4>
                                            <Link to="/Details">
                                                Marketing Financial Analytis
                                            </Link>
                                        </h4>
                                        <p>Corporate - Business Collection</p>
                                    </div>
                                    <Link to="/Details" className="portfolio-btn-five">
                                        <img src={Portsvg1} alt="icon" />
                                    </Link>
                                </div>
                            </div >
                        </div >
                        <div className="col-lg-6">
                            <div
                                className="portfolio-box-five animate fadeInUp wow animated"
                                data-wow-duration="1500ms"
                                data-wow-delay="1400ms"
                            >
                                <div className="portfolio-image-five">
                                    <img
                                        src="assets/images/portfolio/portfolio-details-7.jpg"
                                        alt="portfolio-image"
                                    />
                                </div>
                                <div className="portfolio-details-five">
                                    <div className="portfolio-title-five">
                                        <h4>
                                            <Link to="/Details">Creative Marketing Ideas</Link>
                                        </h4>
                                        <p>Corporate - Business Collection</p>
                                    </div>
                                    <Link to="/Details" className="portfolio-btn-five">
                                        <img src={Portsvg1} alt="icon" />
                                    </Link>
                                </div>
                            </div >
                        </div >
                        <div className="col-lg-6">
                            <div
                                className="portfolio-box-five animate fadeInUp wow animated"
                                data-wow-duration="1500ms"
                                data-wow-delay="1600ms"
                            >
                                <div className="portfolio-image-five">
                                    <img
                                        src="assets/images/portfolio/portfolio-details-8.jpg"
                                        alt="portfolio-image"
                                    />
                                </div>
                                <div className="portfolio-details-five">
                                    <div className="portfolio-title-five">
                                        <h4>
                                            <Link to="/Details">
                                                Digital Marketing For Business
                                            </Link>
                                        </h4>
                                        <p>Corporate - Business Collection</p>
                                    </div>
                                    <Link to="/Details" className="portfolio-btn-five">
                                        <img src={Portsvg1} alt="icon" />
                                    </Link>
                                </div>
                            </div >
                        </div >
                        <div className="col-12">
                            <div
                                className="pagination animate fadeInUp wow animated"
                                data-wow-duration="1500ms"
                                data-wow-delay="1800ms"
                            >
                                <div className="blog-pagination-btn active">
                                    <Link to="#">1</Link>
                                </div>
                                <div className="blog-pagination-btn">
                                    <Link to="#">2</Link>
                                </div>
                                <div className="blog-pagination-btn">
                                    <Link to="#">
                                        <i className="fa-solid fa-chevron-right" />
                                    </Link>
                                </div >
                            </div >
                        </div >
                    </div >
                </div >
            </div >

        </>
    )
}

export default Portfolio
